import { Trans } from "@lingui/macro";
import { UiAlert, UiBox, UiTypography } from "@smp/ui";

export const Success = () => (
  <UiBox display="flex" flexDirection="column">
    <UiBox mb={4}>
      <UiTypography>
        <Trans>
          Your balance will be updated within minutes. A detailed statement can
          be viewed by clicking on the number of free posts on your balance
          page.
        </Trans>
      </UiTypography>
    </UiBox>
    <UiBox>
      <UiAlert variant="warning">
        <Trans>
          There is limit to free posts: you cannot accumulate more than 100 free
          posts.
        </Trans>
      </UiAlert>
    </UiBox>
  </UiBox>
);
